import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AnalyticSessionCreateMutationVariables = Types.Exact<{
  input: Types.AnalyticSessionCreateInput;
}>;


export type AnalyticSessionCreateMutation = { __typename?: 'Mutation', analyticSessionCreate?: { __typename?: 'AnalyticSession', id: string } | null };

export type AnalyticSessionUpdateMutationVariables = Types.Exact<{
  input: Types.AnalyticSessionUpdateInput;
}>;


export type AnalyticSessionUpdateMutation = { __typename?: 'Mutation', analyticSessionUpdate?: { __typename?: 'AnalyticSession', id: string } | null };

export type AnalyticSessionKillMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AnalyticSessionKillMutation = { __typename?: 'Mutation', analyticSessionKill?: { __typename?: 'AnalyticSession', id: string } | null };

export type AnalyticSessionPageCreateMutationVariables = Types.Exact<{
  input: Types.AnalyticSessionPageCreateInput;
}>;


export type AnalyticSessionPageCreateMutation = { __typename?: 'Mutation', analyticSessionPageCreate?: { __typename?: 'AnalyticSessionPage', id: string } | null };

export const AnalyticSessionCreateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"analyticSessionCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticSessionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticSessionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AnalyticSessionCreateGQL extends Apollo.Mutation<AnalyticSessionCreateMutation, AnalyticSessionCreateMutationVariables> {
    document = AnalyticSessionCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnalyticSessionUpdateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"analyticSessionUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticSessionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticSessionUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AnalyticSessionUpdateGQL extends Apollo.Mutation<AnalyticSessionUpdateMutation, AnalyticSessionUpdateMutationVariables> {
    document = AnalyticSessionUpdateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnalyticSessionKillDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"analyticSessionKill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticSessionKill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AnalyticSessionKillGQL extends Apollo.Mutation<AnalyticSessionKillMutation, AnalyticSessionKillMutationVariables> {
    document = AnalyticSessionKillDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AnalyticSessionPageCreateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"analyticSessionPageCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticSessionPageCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticSessionPageCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class AnalyticSessionPageCreateGQL extends Apollo.Mutation<AnalyticSessionPageCreateMutation, AnalyticSessionPageCreateMutationVariables> {
    document = AnalyticSessionPageCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }